import { parse } from "graphql";
import { SchemaClient } from "../../../common/GraphqlClient";
import { SchemaClientKinds, Source } from "../../../common/Source";
import { EMPTY_VALUE } from "../../../Schema";
import { uniqueSortedLabels } from "./filterValues";

/** One distinct `maintenancePerformedBy` value in use, from `instrumentFilterValues`. */
export type Maintainer = {
  filterValue: string;
};

/**
 * Maintainers, read from the OpenSearch-backed `instrumentFilterValues` query, as `Tags.ts`
 * does, for the `maintenancePerformedBy` attribute.
 *
 * GraphQL only; see {@link getMaintainers}.
 */
const listMaintainers: Source<Maintainer[]> = {
  graphql: parse(`
    query instrumentFilterValues($nextToken: String) {
      instrumentFilterValues(
        filterAttribute: "maintenancePerformedBy",
        nextToken: $nextToken
      ) {
        nextToken
        items {
          filterValue
        }
      }
    }
  `),
};

/**
 * Maintainer filter options.
 *
 * Answers `[]` for any client that is not GraphQL.
 * Safe as a stub because these values only populate a grid filter dropdown and never reach
 * `DataManager`.
 *
 * @param client - Read client for the master data.
 * @returns Maintainer names, deduplicated and sorted.
 */
export const getMaintainers = async (client: SchemaClient): Promise<string[]> => {
  if (client.kind !== SchemaClientKinds.GRAPHQL) {
    return [];
  }
  const maintainers = await client.queryList(listMaintainers);
  const items = maintainers === EMPTY_VALUE ? [] : maintainers ?? [];
  return uniqueSortedLabels(items.map((maintainers) => maintainers.filterValue));
};
